import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { ChevronDown, EyeOff, Filter, Trash2 } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@shadcn-in-nx/ui/dropdown-menu";

function ColumnMenu({ columnName, onHide, onFilter, onDelete }) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="sm"
                    className="opacity-0 group-hover:opacity-100 h-6 w-6 p-0"
                >
                    <ChevronDown className="w-3 h-3" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
                <DropdownMenuItem onClick={() => onHide(columnName)}>
                    <EyeOff className="w-4 h-4 mr-2" />
                    Hide Column
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => onFilter(columnName)}>
                    <Filter className="w-4 h-4 mr-2" />
                    Filter
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => onDelete(columnName)} className="text-red-600">
                    <Trash2 className="w-4 h-4 mr-2" />
                    Delete Column
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default ColumnMenu;
